import type { Space } from '@mail/cross-sizes-utils';

import type { CheckPossibilityStatus } from './vkMusic.helpers';

export enum VkMusicBundleVkidSource {
    noVkid = 'no_vkid',
    social = 'social',
    login = 'login',
    silent = 'silent',
    bind = 'bind',
    choosen = 'choosen',
}

export interface VkMusicBundleInfo {
    canOffer: boolean;
    vkid?: VKIDInfo;
    tariffInfo?: VkMusicBundleTariffInfo;
    vkMusicCheckStatus?: CheckPossibilityStatus;
    mailSpaceCheckStatus?: CheckPossibilityStatus;
}

export interface VkMusicBundleState {
    fullName: string;
    vkid: string;

    data: VkMusicBundleInfo & {
        isLoaded: boolean;
        isLoading: boolean;
    };
}

export interface VKIDInfo {
    vkidSource: VkMusicBundleVkidSource;
    login: number;
    firstName: string;
    lastName: string;
    phone?: string;
    avatar?: string;
}

export interface VkMusicBundleTariffInfo {
    id: string;
    space: Space;
    usualPrice: number;
    discount?: number;
    isTrial: boolean;
}
